import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'medsurf-notice',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './notice.component.html',
    styleUrls: ['./notice.component.scss'],
    standalone: false
})
export class NoticeComponent {
  /**
   * Inputs
   */
  @Input() public includes: Array<string>;

  /**
   * Members
   */
  public showNotice = false;
  public dismissed = false;

  /**
   * Dismiss Notice
   */
  public dismissNotice() {
    this.dismissed = true;
    this.showNotice = false;
  }
}
